import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect } from "react";

const useReplaceRouterPath = (routerPath: string) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const replaceRouterPath = useCallback(() => {
    const isRouteFromMedicalDashBoard = sessionStorage.getItem(
      "isRouteFromMedicalDashBoard"
    );

    if (isRouteFromMedicalDashBoard === "true") {
      const search = searchParams.toString();
      const url = search ? `${pathname}?${search}` : pathname;
      router.replace(url);
    }
  }, [pathname, router, searchParams]);

  useEffect(() => {
    replaceRouterPath();
  }, [routerPath, pathname, router, replaceRouterPath]);
};

export default useReplaceRouterPath;
